import { Box, Flex, Text } from "@chakra-ui/react";
import { useMemo } from "react";
import { useHookstate } from "@hookstate/core";
import { Bundle } from "../../../../types";
import { appStore } from "../../../../hookstate/appStore";

interface BundleTagsSectionProps {
  bundle: Bundle;
  hasDiscount: boolean;
}

export function BundleTagsSection({
  bundle,
  hasDiscount,
}: BundleTagsSectionProps) {
  const appInit = useHookstate(appStore.init).get({
    noproxy: true,
  });

  const bundleTags = useMemo(() => {
    const tags: string[] = [];

    const releaseTagsGroup = appInit?.comic_facet_groups?.find(
      (group: any) => group.id === 2,
    );

    if (
      bundle?.comic_facets &&
      Array.isArray(bundle.comic_facets) &&
      releaseTagsGroup
    ) {
      bundle.comic_facets.forEach((facetItem) => {
        if (facetItem?.comic_facet_group_option_id) {
          const option = releaseTagsGroup.comic_facet_group_options?.find(
            (opt: any) => opt.id === facetItem.comic_facet_group_option_id,
          );
          if (option?.display_name) {
            tags.push(option.display_name);
          }
        }
      });
    }

    return [...new Set(tags)];
  }, [bundle, hasDiscount, appInit]);

  return (
    <Flex flexWrap="wrap" gap="6px" width="100%">
      {bundleTags.map((tag) => (
        <Box
          key={tag}
          bg="transparent.white.10"
          borderRadius="full"
          py="8px"
          px="12px"
          width="fit-content"
          userSelect="none"
        >
          <Text
            fontFamily="Roboto"
            textAlign="center"
            fontSize="12px"
            lineHeight="14.06px"
            fontWeight="500"
            color="dune.700"
          >
            {tag}
          </Text>
        </Box>
      ))}
    </Flex>
  );
}
